module.exports = __webpack_public_path__ + "static/media/social-icon-x-yellow.27215a4a.svg";